import React, { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from 'react'
import styles from './Filters.module.scss'
import Collapsable, { CollapsableProps } from 'components/SA/Collapsable'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import { updateClientSideUrl } from 'components/SA/Facets/helpers/url'
import classNames from 'classnames'

export type FiltersType = CollapsableProps

type FiltersPanelProps = {
  filters: ReadonlyArray<FiltersType>
  baseUrl: string
  nextAppRoute: string
  setIsFiltersVisible: Dispatch<SetStateAction<boolean>>
  closeModal?: () => void
  totalFiltered?: number
  isClearHideFilterVisible?: boolean
  customClearFilterCallback?: () => void
}

const FiltersPanel: FC<FiltersPanelProps> = ({
  filters,
  baseUrl,
  nextAppRoute,
  setIsFiltersVisible,
  closeModal,
  totalFiltered = 0,
  isClearHideFilterVisible,
  customClearFilterCallback,
}) => {
  const [isScrollable, setIsScrollable] = useState(false)
  const filterParentDivRef = useRef<HTMLDivElement>(null)

  const handleClearFilters = () => {
    handleScrollToTop(() => {
      if (!!customClearFilterCallback) {
        customClearFilterCallback()
        return
      }

      updateClientSideUrl(baseUrl, nextAppRoute)
    })
  }

  const handleHideFilters = () => {
    setIsFiltersVisible(false)
  }

  const checkScrollable = () => {
    if (filterParentDivRef.current) {
      setIsScrollable(filterParentDivRef.current.scrollHeight > window.innerHeight)
    }
  }

  const handleClearButton = () => {
    handleClearFilters()
  }

  // this is to fix the mobile button at the bottom in iPhone/iPad on side drawer
  useEffect(() => {
    checkScrollable()
  }, [filterParentDivRef?.current?.scrollHeight, totalFiltered])

  return (
    <div ref={filterParentDivRef}>
      <div className={styles.filtersPanelContainer}>
        {isClearHideFilterVisible ? (
          <div className={styles.filtersPanelActionsBox}>
            <button onClick={handleHideFilters} data-type='hide-filter'>
              Hide Filter
            </button>
            <button onClick={handleClearFilters}>Clear Filter</button>
            <span>Filter</span>
            <hr />
          </div>
        ) : (
          <div className={styles.firstHrContainer}>
            <span>Filter</span>
            <hr />
          </div>
        )}
        <div className={styles.filtersPanelContent}>
          {filters.map(({ title, content, disableCollapsable, isOpen, isToggle, onClick }) => (
            <>
              <Collapsable
                title={title}
                content={content}
                disableCollapsable={disableCollapsable}
                isOpen={isOpen}
                isToggle={isToggle}
                onClick={onClick}
              />
              <hr />
            </>
          ))}
        </div>
      </div>
      <div
        className={classNames(styles.mobileButtonContainer, {
          [styles.mobileButtonContainerSticky]: isScrollable,
        })}
      >
        <button className={styles.clearButton} onClick={handleClearButton}>
          Clear
        </button>
        <button className={styles.showResultsButton} onClick={closeModal}>
          Show {totalFiltered.toLocaleString('en-US')} artworks
        </button>
      </div>
    </div>
  )
}

export default FiltersPanel
